/**
 * "View Tx plan" menu action (PA form variant): analytics + opens image viewer.
 * Driven by Postgres-backed `generalOrderDetails` (`GeneralOrderDetails`).
 *
 * @module paFormThreeDotsMenu/handleViewTxPlan
 */
import { GeneralOrderDetails } from "../../../../data-model/medicalPaOrdersModel";
import { ScreenNamesForBigQuery } from "../../../../enums/eventsData";
import { EventsName } from "../../../../enums/eventsName";
import { ModalId } from "../../../../enums/modalId";
import { setOpenedModalId } from "../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../redux/store/store";
import { apiWorkerManager } from "../../../../workerManagers/workerManager";

/** Parameters for {@link handleViewTxPlan}. */
export interface HandleViewTxPlanParams {
  dispatch: AppDispatch;
  generalOrderDetails: GeneralOrderDetails;
  orgId: string;
  userId: string;
  userEmail: string;
  payerName: string;
  screenName: ScreenNamesForBigQuery;
}

/**
 * Handles the "View Tx Plan" action for the PA form three-dots menu.
 * Opens the image viewer modal with treatment plan screenshots.
 *
 * @param params - Parameters for the action
 */
export const handleViewTxPlan = ({
  dispatch,
  generalOrderDetails,
  orgId,
  userId,
  userEmail,
  payerName,
  screenName,
}: HandleViewTxPlanParams): void => {
  apiWorkerManager.enqueueAndProcess({
    patient_id:
      generalOrderDetails?.demographics?.patient_id ??
      generalOrderDetails?.demographics?.patient_mrn ??
      "",
    order_id: generalOrderDetails?.order_id ?? "",
    org_id: orgId ?? "",
    event_name: EventsName.VIEW_TX_PLAN_CLICKED,
    user_id: userId,
    user_email: userEmail,
    additional_data: {
      screen_name: screenName,
      payer_name: payerName,
    },
  });

  dispatch(setOpenedModalId({ id: ModalId.IMAGE_VIEWER_MODAL }));
};
